// extracted by mini-css-extract-plugin
export default {"root":"PartitionsSection_root__TGo+Q","title":"PartitionsSection_title__lrCxR","partitions":"PartitionsSection_partitions__HOA6i","partition":"PartitionsSection_partition__KEpF9"};